var _a;
import { __spreadArrays } from "tslib";
export var AppState;
(function (AppState) {
    AppState[AppState["HOME"] = 10] = "HOME";
    AppState[AppState["HC_ARTICLE_NEW"] = 19] = "HC_ARTICLE_NEW";
    AppState[AppState["HC_ARTICLES"] = 20] = "HC_ARTICLES";
    AppState[AppState["HC_TOP_ARTICLES"] = 200] = "HC_TOP_ARTICLES";
    AppState[AppState["HC_ARTICLE"] = 21] = "HC_ARTICLE";
    AppState[AppState["HC_CATEGORIES"] = 22] = "HC_CATEGORIES";
    AppState[AppState["HC_SETTINGS"] = 23] = "HC_SETTINGS";
    AppState[AppState["HC_ARTICLE_COMMENT"] = 24] = "HC_ARTICLE_COMMENT";
    AppState[AppState["HD_TICKETS"] = 30] = "HD_TICKETS";
    AppState[AppState["HD_ONE_INBOX"] = 100] = "HD_ONE_INBOX";
    AppState[AppState["HD_ONE_INBOX_FULL_WIDTH"] = 110] = "HD_ONE_INBOX_FULL_WIDTH";
    AppState[AppState["HD_TICKET"] = 31] = "HD_TICKET";
    AppState[AppState["HD_SAVED_REPLIES"] = 32] = "HD_SAVED_REPLIES";
    AppState[AppState["HD_SETTINGS"] = 33] = "HD_SETTINGS";
    AppState[AppState["HD_CRM"] = 34] = "HD_CRM";
    AppState[AppState["HD_CRM_COMPANY"] = 35] = "HD_CRM_COMPANY";
    AppState[AppState["HD_CALLCENTER"] = 420] = "HD_CALLCENTER";
    AppState[AppState["HD_CALLCENTER_CALLS_WAITING"] = 4420] = "HD_CALLCENTER_CALLS_WAITING";
    AppState[AppState["HD_CALLCENTER_CALLS_IN_PROGRESS"] = 4421] = "HD_CALLCENTER_CALLS_IN_PROGRESS";
    AppState[AppState["HD_CALLCENTER_CALLS_COMPLETED"] = 4422] = "HD_CALLCENTER_CALLS_COMPLETED";
    AppState[AppState["HD_CALLCENTER_CALLS_INCOMPLETE"] = 4423] = "HD_CALLCENTER_CALLS_INCOMPLETE";
    AppState[AppState["HD_CALLCENTER_CALLS_VOICEMAIL"] = 4424] = "HD_CALLCENTER_CALLS_VOICEMAIL";
    AppState[AppState["CC_SETTINGS"] = 421] = "CC_SETTINGS";
    AppState[AppState["HD_SETTINGS_CHANNELS"] = 330] = "HD_SETTINGS_CHANNELS";
    AppState[AppState["HD_SETTINGS_CHANNELS_FB"] = 3330] = "HD_SETTINGS_CHANNELS_FB";
    AppState[AppState["HD_SETTINGS_CHANNELS_WEB"] = 3331] = "HD_SETTINGS_CHANNELS_WEB";
    AppState[AppState["HD_SETTINGS_CHANNELS_EMAIL"] = 3332] = "HD_SETTINGS_CHANNELS_EMAIL";
    AppState[AppState["HD_SETTINGS_SECURITY"] = 331] = "HD_SETTINGS_SECURITY";
    AppState[AppState["HD_SETTINGS_SECURITY_SETTINGS"] = 3310] = "HD_SETTINGS_SECURITY_SETTINGS";
    AppState[AppState["HD_SETTINGS_SECURITY_SPAM"] = 3311] = "HD_SETTINGS_SECURITY_SPAM";
    AppState[AppState["HD_SETTINGS_AGENT_TOOLS"] = 332] = "HD_SETTINGS_AGENT_TOOLS";
    AppState[AppState["HD_SETTINGS_CUSTOM_FIELDS"] = 333] = "HD_SETTINGS_CUSTOM_FIELDS";
    AppState[AppState["HD_SETTINGS_RULE_ENGINE"] = 334] = "HD_SETTINGS_RULE_ENGINE";
    AppState[AppState["HD_SETTINGS_SLA_SETTINGS"] = 335] = "HD_SETTINGS_SLA_SETTINGS";
    AppState[AppState["HD_SETTINGS_AGENT_FIELDS"] = 336] = "HD_SETTINGS_AGENT_FIELDS";
    AppState[AppState["HD_SETTINGS_COMPANY_FIELDS"] = 337] = "HD_SETTINGS_COMPANY_FIELDS";
    AppState[AppState["HD_SETTINGS_CSAT"] = 338] = "HD_SETTINGS_CSAT";
    AppState[AppState["INSIGHTS"] = 40] = "INSIGHTS";
    AppState[AppState["TEAM"] = 50] = "TEAM";
    AppState[AppState["SETTINGS"] = 60] = "SETTINGS";
    AppState[AppState["SPOTTER"] = 500] = "SPOTTER";
    AppState[AppState["WIDGETS_OLD"] = 70] = "WIDGETS_OLD";
    AppState[AppState["WIDGETS"] = 80] = "WIDGETS";
    AppState[AppState["MY_STATISTICS"] = 90] = "MY_STATISTICS";
})(AppState || (AppState = {}));
var states = {
    home: '/',
    hc: {
        newArticle: '/hc/articles/new',
        articles: '/hc/articles',
        topArticles: '/hc/top-articles',
        article: '/hc/article',
        articleComment: '/kb/article',
        categories: '/hc/categories',
        topCategories: '/hc/top-categories',
        settings: '/hc/manage',
    },
    ticketing: {
        tickets: '/helpdesk/tickets',
        oneInbox: {
            index: '/helpdesk/one-inbox',
            fullWidth: '/helpdesk/one-inbox/full-width',
        },
        crm: '/helpdesk/contacts',
        crmCompanies: '/helpdesk/contacts/companies',
        crmCompany: '/helpdesk/contacts/company',
        settings: {
            index: '/helpdesk/manage',
            channels: {
                index: '/helpdesk/manage/channels',
                facebook: '/helpdesk/manage/channels/facebook',
                web: '/helpdesk/manage/channels/web',
                email: '/helpdesk/manage/channels/email',
            },
            security: {
                index: '/helpdesk/manage/spam-and-security',
                settings: '/helpdesk/manage/spam-and-security/security',
                spam: '/helpdesk/manage/spam-and-security/spam-filter'
            },
            agentTools: '/helpdesk/manage/agent-tools',
            customFields: '/helpdesk/manage/custom-fields',
            agentFields: '/helpdesk/agent-fields',
            companyFields: '/helpdesk/company-fields',
            ruleEngine: '/settings/tickets/rule-engine',
            slaSettings: '/settings/tickets/sla-settings',
            csat: '/settings/tickets/csat-settings',
        },
        ticket: '/helpdesk/ticket',
        savedReplies: '/helpdesk/saved-replies'
    },
    callcenter: {
        index: '/callcenter',
        calls: {
            waiting: '/callcenter/calls/waiting',
            progress: '/callcenter/calls/progress',
            completed: '/callcenter/calls/completed',
            unanswered: '/callcenter/calls/unanswered',
            voiceMail: '/callcenter/calls/voice-mail',
        },
        settings: {
            index: '/settings/callcenter'
        }
    },
    insights: '/insights',
    team: {
        index: '/team',
        members: '/settings/team/members',
    },
    appSettings: '/settings',
    widgetsOld: '/widgets-old',
    widgets: '/settings/widgets',
    myStatistics: '/my-statistics',
    spotter: '/settings/tools/spotter',
};
var urlParamsToStringArray = function (urlParams) {
    return Object.keys(urlParams).reduce(function (res, currKey) {
        var _a;
        var currParamValue = urlParams[currKey];
        return currParamValue.constructor === Array ?
            // tslint:disable-next-line:max-line-length
            (currParamValue.length ? __spreadArrays(res, [currKey + "=" + currParamValue[0]], urlParamsToStringArray((_a = {}, _a[currKey] = currParamValue.slice(1), _a))) : res)
            : __spreadArrays(res, [currKey + "=" + currParamValue]);
    }, []);
};
export var urlParamsToString = function (urlParams) {
    return urlParamsToStringArray(urlParams).join('&');
};
var stateToUrlMap = (_a = {},
    _a[AppState.HOME] = function () { return states.home; },
    // tslint:disable-next-line:max-line-length
    _a[AppState.HC_ARTICLE_NEW] = function (newArticleParams) { return states.hc.newArticle + (newArticleParams ? '?' + urlParamsToString(newArticleParams) : ''); },
    // tslint:disable-next-line:max-line-length
    _a[AppState.HC_ARTICLES] = function (articleListParams) { return states.hc.articles + (articleListParams ? '?' + urlParamsToString(articleListParams) : ''); },
    _a[AppState.HC_TOP_ARTICLES] = function () { return states.hc.topArticles; },
    _a[AppState.HC_ARTICLE] = function (id) { return states.hc.article + '/' + id; },
    _a[AppState.HC_CATEGORIES] = function (id) { return states.hc.categories + (id ? '/' + id : ''); },
    _a[AppState.HC_SETTINGS] = function () { return states.hc.settings; },
    _a[AppState.HC_ARTICLE_COMMENT] = function (config) { return states.hc.articleComment + "/" + config.articleId + "/" + config.locale + "?commentId=" + config.commentId; },
    // tslint:disable-next-line:max-line-length
    _a[AppState.HD_TICKETS] = function (ticketListParams) { return states.ticketing.tickets + (ticketListParams ? '?' + urlParamsToString(ticketListParams) : ''); },
    _a[AppState.HD_TICKET] = function (id) { return states.ticketing.ticket + '/' + id; },
    _a[AppState.HD_ONE_INBOX] = function (id) { return states.ticketing.oneInbox.index + (id ? '/' + id : ''); },
    _a[AppState.HD_ONE_INBOX_FULL_WIDTH] = function (id) { return states.ticketing.oneInbox.fullWidth + '/' + id; },
    _a[AppState.HD_SAVED_REPLIES] = function () { return states.ticketing.savedReplies; },
    _a[AppState.HD_SETTINGS] = function () { return states.ticketing.settings.index; },
    _a[AppState.CC_SETTINGS] = function () { return states.callcenter.settings.index; },
    _a[AppState.HD_CALLCENTER] = function () { return states.callcenter.index; },
    _a[AppState.HD_CALLCENTER_CALLS_COMPLETED] = function () { return states.callcenter.calls.completed; },
    _a[AppState.HD_CALLCENTER_CALLS_WAITING] = function () { return states.callcenter.calls.waiting; },
    _a[AppState.HD_CALLCENTER_CALLS_INCOMPLETE] = function () { return states.callcenter.calls.unanswered; },
    _a[AppState.HD_CALLCENTER_CALLS_IN_PROGRESS] = function () { return states.callcenter.calls.progress; },
    _a[AppState.HD_CALLCENTER_CALLS_VOICEMAIL] = function () { return states.callcenter.calls.voiceMail; },
    _a[AppState.HD_SETTINGS_AGENT_TOOLS] = function () { return states.ticketing.settings.agentTools; },
    _a[AppState.HD_SETTINGS_SECURITY] = function () { return states.ticketing.settings.security.index; },
    _a[AppState.HD_SETTINGS_SECURITY_SETTINGS] = function () { return states.ticketing.settings.security.settings; },
    _a[AppState.HD_SETTINGS_SECURITY_SPAM] = function () { return states.ticketing.settings.security.spam; },
    _a[AppState.HD_SETTINGS_CHANNELS] = function () { return states.ticketing.settings.channels.index; },
    _a[AppState.HD_SETTINGS_CHANNELS_FB] = function () { return states.ticketing.settings.channels.facebook; },
    _a[AppState.HD_SETTINGS_CHANNELS_WEB] = function () { return states.ticketing.settings.channels.web; },
    _a[AppState.HD_SETTINGS_CHANNELS_EMAIL] = function () { return states.ticketing.settings.channels.email; },
    _a[AppState.HD_SETTINGS_CUSTOM_FIELDS] = function () { return states.ticketing.settings.customFields; },
    _a[AppState.HD_SETTINGS_RULE_ENGINE] = function (id) { return states.ticketing.settings.ruleEngine + (id ? "/" + id : ''); },
    _a[AppState.HD_SETTINGS_SLA_SETTINGS] = function () { return states.ticketing.settings.slaSettings; },
    _a[AppState.HD_SETTINGS_AGENT_FIELDS] = function () { return states.ticketing.settings.agentFields; },
    _a[AppState.HD_SETTINGS_COMPANY_FIELDS] = function () { return states.ticketing.settings.companyFields; },
    _a[AppState.HD_SETTINGS_CSAT] = function () { return states.ticketing.settings.csat; },
    // tslint:disable-next-line:max-line-length
    _a[AppState.INSIGHTS] = function (insightsPageParams) { return states.insights + (insightsPageParams ? '?' + urlParamsToString(insightsPageParams) : ''); },
    _a[AppState.TEAM] = function (agentId) { return agentId ? states.team.members + "?" + urlParamsToString({ agentId: agentId }) : states.team.index; },
    _a[AppState.SETTINGS] = function () { return states.appSettings; },
    _a[AppState.WIDGETS_OLD] = function () { return states.widgetsOld; },
    // tslint:disable-next-line:max-line-length
    _a[AppState.WIDGETS] = function (widgetParams) { return states.widgets + (widgetParams ? '?' + urlParamsToString(widgetParams) : ''); },
    _a[AppState.MY_STATISTICS] = function () { return states.myStatistics; },
    _a[AppState.HD_CRM_COMPANY] = function () { return states.ticketing.crmCompany; },
    _a[AppState.SPOTTER] = function (recipeId) { return recipeId ? states.spotter + "?" + urlParamsToString({ recipeId: recipeId }) : states.spotter; },
    _a);
export var listenToStateChangeInAngular = function ($rootScope, cb) {
    var removeHandler = $rootScope.$on('$stateChangeSuccess', function () { return cb(); });
    return removeHandler;
};
var AppNavigator = /** @class */ (function () {
    function AppNavigator() {
    }
    AppNavigator.getRelativeLink = function (state, data) {
        return stateToUrlMap[state](data);
    };
    AppNavigator.getStateTranslateKey = function (state) {
        var _a;
        var translateKeyMap = (_a = {},
            _a[AppState.HOME] = 'home',
            _a[AppState.HC_ARTICLES] = 'articles',
            _a[AppState.HC_TOP_ARTICLES] = 'top-articles',
            _a[AppState.HC_CATEGORIES] = 'categories',
            _a[AppState.HC_SETTINGS] = 'helpcenter-settings',
            _a[AppState.HD_TICKETS] = 'tickets',
            _a[AppState.CC_SETTINGS] = 'callcenter-settings',
            _a[AppState.HD_CALLCENTER] = 'callcenter',
            _a[AppState.HD_SAVED_REPLIES] = 'saved-replies',
            _a[AppState.HD_SETTINGS] = 'ticket-settings',
            _a[AppState.INSIGHTS] = 'insights',
            _a[AppState.TEAM] = 'team-members',
            _a[AppState.SETTINGS] = 'settings',
            _a[AppState.WIDGETS_OLD] = 'widgets',
            _a[AppState.WIDGETS] = 'widgets',
            _a[AppState.SPOTTER] = 'spotter',
            _a);
        return translateKeyMap[state];
    };
    AppNavigator.getAppLink = function (state, data) {
        return "/app" + this.getRelativeLink(state, data);
    };
    AppNavigator.getRelativeUrlFromLink = function (link) {
        var reg = new RegExp('\/app\/[^?&#]*');
        var appUrl = reg.exec(link);
        return appUrl && appUrl.toString() ? appUrl.toString().replace('/app', '') : '';
    };
    AppNavigator.getAbsoluteLink = function (state, data) {
        var href = window.location.href;
        var baseUrl = href.substring(0, href.indexOf('/app/'));
        return "" + baseUrl + this.getAppLink(state, data);
    };
    AppNavigator.getAppState = function (link) {
        var relativeUrl = AppNavigator.getRelativeUrlFromLink(link);
        var matches = Object.keys(stateToUrlMap)
            .reduce(function (result, item) {
            var currState = parseInt(item, 10);
            var thisHackCanBeSolvedByANewStructure = '';
            var route = stateToUrlMap[currState](thisHackCanBeSolvedByANewStructure);
            if (relativeUrl === route) {
                result.push({ priority: 999, state: currState });
            }
            else {
                var reg = new RegExp(route);
                if (reg.test(relativeUrl)) {
                    var hackishRegexPriority = route.split('/').length;
                    result.push({ exact: false, state: currState, priority: hackishRegexPriority });
                }
            }
            return result;
        }, []);
        matches.sort(function (a, b) { return a.priority > b.priority ? -1 : 1; });
        var state = matches.length ? matches[0].state : 0;
        return {
            state: state,
            params: {}
        };
    };
    AppNavigator.onAppStateChange = function ($rootScope, cb) {
        var _this = this;
        return listenToStateChangeInAngular($rootScope, function () {
            var url = window.location.href;
            var _a = _this.getAppState(url), state = _a.state, params = _a.params;
            cb(state, params);
        });
    };
    return AppNavigator;
}());
export { AppNavigator };
//# sourceMappingURL=app-navigator.js.map